import { ClassAttributes, createElement, FC } from 'react';

import RouteLifecycleWrapper from '../component/primitive/RouteLifecycleWrapper';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as StateConsumer } from '../context/state';
import _ConfigurationPage from '../page/ConfigurationPage';

type Props = ClassAttributes<HTMLElement>;

const ConfigurationPage: FC<Props> = () => (
  <DependencyConsumer>
    {(dependency) => (
      <StateConsumer>
        {(state) => (
          <RouteLifecycleWrapper onMount={() => dependency.authenticationUsecase.needSignedIn()}>
            <_ConfigurationPage
              language={state.language}
              onChangeLanguage={(_: any, language: string) =>
                dependency.configurationChangingUsecase.changeLanguage(language)
              }
            />
          </RouteLifecycleWrapper>
        )}
      </StateConsumer>
    )}
  </DependencyConsumer>
);

export default ConfigurationPage;
